import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import moment from 'moment';
import { format, parseISO, fromUnixTime, formatDistanceToNow } from 'date-fns';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { Link } from 'react-router-dom';

import mixpanel from 'mixpanel-browser';

// Firebase
import { db } from '../../config/firebase-config';
import { collection, getDocs, getDoc, doc, query, where } from 'firebase/firestore';

// Redux
import { connect } from 'react-redux';


// Actions
import { addLike, deletePost } from '../../actions/postActions';
import { getUserById } from '../../actions/authActions';
import { createChat, addMessage  } from '../../actions/chatActions';
import { toggleAuthModal } from '../../actions/navActions';
import { setAlert } from '../../actions/alertActions';

// components - material UI
import { Avatar, Button } from '@material-ui/core';
import DefaultAvatar from 'react-avatar';
import Post from '../Post/Post';
import Tag from '../common/Tag';

import ImageBlock from '../common/ImageBlock';

// Icons - material UI
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import RepeatIcon from '@material-ui/icons/Repeat';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import LinkIcon from '@material-ui/icons/Link';
import CheckIcon from '@material-ui/icons/Check';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import PauseIcon from '@material-ui/icons/Pause';
import LocalMallOutlinedIcon from '@material-ui/icons/LocalMallOutlined';
import LinkOutlinedIcon from '@material-ui/icons/LinkOutlined';
import MailIcon from '@material-ui/icons/Mail';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';

// Modal
import Modal from '../modal/Modal';
import ModalContainer from '../modal/ModalContainer';

// DraftJS
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import { Fragment } from 'react';
import Verification_Badge from '../common/Verification_Badge';

const Detail = ({
        post,
        auth,
        ad,
        nav: {
            website,
            website_loading
        },
        setAlert,
        addLike,
        deletePost,
        getUserById,
        createChat,
        addMessage,
        toggleAuthModal,
        toggleCommentModal,
        image,
        history,
        isTablet,
        commentList,
        likeList,
        setScrollDirection,
        setOldScrollY,
        oldScrollY,
        safeTrackPostAnalytics
    }) => {
        
        // Tracks the like status of post
        const [liked, setLiked] = useState(false);
        // Flag for checking if like is properly updated
        const [checkLike, setCheckLike] = useState(false);

        // Flag for checking if group's name should display as author of post
        const [showGroupName, setShowGroupName] = useState(false);

        // --- Convert DraftJS text to HTML text

        // Tracks whether the text has been converted
        const [gotText, setGotText] = useState(false);
        // Stores the converted text
        const [textState, setTextState] = useState(null);
        const [rawTextState, setRawTextState] = useState(null);

        // Check if post has image - for font size reasons
        const [hasImg, setHasImg] = useState(false);
        // Flag for checking if hasImg is properly updated
        const [checkHasImg, setCheckHasImg] = useState(false);
        const [imgHeight, setImgHeight] = useState(200);

        // Toggle Dropdwon
        const [dropdown, setDropdown] = useState(false);
        const [shareDropdown, setShareDropdown] = useState(false);

        // Stores the height of a toggle menu
        const [menuHeight, setMenuHeight] = useState(null);

        // Modal toggles
        const [deleteModal, setDeleteModal] = useState(false);
        const [messageModal, setMessageModal] = useState(false);

        // Tracks the status of copying
        const [copied, setCopied] = useState(false);
        
        // Controls the visibility of a copied modal
        const [copiedModal, setCopiedModal] = useState(false);

        // --- Parent Posts for comments ------
        const [parentPosts, setParentPosts] = useState([]);
        const [gotParentPosts, setGotParentPosts] = useState(false);

        const [gotTopNav, setGotTopNav] = useState(false);

        // --- END Parent Posts for comments

        // --- Get parent post for displaying the 'replying to' ---

        const [gotParentPost, setGotParentPost] = useState(false);

        const [replyToPost, setReplyToPost] = useState(null);

        // --- END: Get parent post for displaying the 'replying to' ---

        // -- Text Truncation Functions ---
        
        // is text expanded?
        const [isExpanded, setIsExpanded] = useState(true);
        const CHARACTER_LIMIT = 200;
        const [shouldTruncate, setShouldTruncate] = useState(false);
        
            // -- END: Text Truncation Functions ---

        // Get the current URL and extract the "redirect" parameter
        const url_filter = (window.location.href);
        const url = new URL(url_filter);
        const showMessageModal = url.searchParams.get("redirect");

        useEffect(() => {
            if(post) {

                // --- If the showMessageModal flag is set to 'true', 
                // --- toggle the message modal and redirect to the post

                if(showMessageModal === 'true') {
                    toggleMessageModal();
    
                    window.location.href = `/post/${post._id}`;
                }

                // Flag for checking if group's name should display as author of post
                if(!post.isSponsored && !website_loading && !website && post.group?.name) {
                    setShowGroupName(true);
                }
            }

        }, [post])

        useEffect(() => {

            if(parentPosts.length > 0) {
                // Scroll to the top of the main postDetail component and below all parent posts
                executeScroll();
            }

        }, [gotParentPosts])

        useEffect(() => {

            // Set a timeout to hide the copied modal after 2 seconds
            setTimeout(() => {
                setCopiedModal(false);
            }, 2000);

        }, [copiedModal]);

        useEffect(() => {

            // Set a timeout to hide the share dropdown and reset the copied flag after 1 second
            setTimeout(() => {
                setShareDropdown(false);
                setCopied(false);
            }, 1000);
        }, [copied]);

        // Fetch the parent posts and put them in a state array
        useEffect(() => {
            if (!gotParentPosts) {

              const fetchParentPosts = async (postData) => {

                let postDocument = postData;
        
                while (postDocument.post_commented_on !== null) {

                  const parentPostRef = doc(db, 'posts', postDocument.post_commented_on);

                  try {

                    const parentPostSnapshot = await getDoc(parentPostRef);

                    setParentPosts((state) => [
                        { ...parentPostSnapshot.data(), _id: parentPostSnapshot.id, commentsOfComments: [{}] }, // add commentsOfComments w/ empty obj to display the thread line in the post component
                        ...state,
                    ]);
        
                    postDocument = parentPostSnapshot.data();

                  } catch (error) {

                    console.log('ERROR');
                    console.log(error);
                    break;
                  }
                }
              };
        
              fetchParentPosts(post)
                .then(() => {
                  setGotParentPosts(true);
                })
                .catch((error) => {
                  console.log('ERROR');
                  console.log(error);
                });
            }
        }, [gotParentPosts, post]);

        // --- Get parent post for displaying the 'replying to' ---

        const getParentPost = async () => {
            if(!post.post_commented_on) return;
            console.log('Getting parent post');
            try {
                const docRef = doc(db, 'posts', post.post_commented_on);
                const postData = await getDoc(docRef);
                setReplyToPost({ ...postData.data(), _id: postData.id });
            } catch (error) {
                console.log('Failed to get parent post');
            }
        }
    
        if(!gotParentPost && post.post_commented_on) {
            getParentPost();
    
            setGotParentPost(true);
        }

        // --- END: Get parent post for displaying the 'replying to' ---

        const handleLike = (postId) => {

            // If the user is authenticated, add a like to the post and toggle the liked state
            if(auth.user) {
                addLike({ postId, fromUserData: auth.user, postData: post });
                setLiked(!liked);
            } else {

                // If the user is not authenticated, fetch the user by ID and toggle the authentication modal
                getUserById(post.user._id);
                toggleAuthModal('like');
            }
        }

        // Redirect to the create comment page for the current post
        const redirectComment = () => {
            window.location.href = `/create/comment/${post._id}`;
        }

        // Copy Modal logic

        const toggleCopiedModal = () => {

            // --- Close other dropdowns and set the copied alert message

            setDropdown(false);
            setShareDropdown(false);

            // -- Analytics stuff --

            // Only track analytics if post is an active Ad
            if(ad.ads && ad.ads?.length > 0 && ad.ads[0].status === 'active' && post._id) {
                console.log('TRACKING POST ANALYTICS')
                safeTrackPostAnalytics('copied_link', post._id);
            }

            // -- END: Analytics stuff --
            
            // setCopiedModal(!copiedModal);
            setAlert('Copied to clipboard', `${!auth.loading && auth.isAuthenticated ? 'okay' : 'success'}`);
        }

        // Delete Modal logic

        const toggleDeleteModal = () => {

            // Close other dropdowns and toggle the delete modal
            setDropdown(false)
            setDeleteModal(!deleteModal);
        }
        
        const handleDelete = () => {
            if(post) {
                let stored_id = post._id

                // Call the deletePost function to delete the post
                deletePost(post._id);

                // Mixpanel event tracking for deleting a post
                if (process.env.NODE_ENV === 'production') {
                    mixpanel.track("Delete Post", {
                        "Post ID": `${stored_id}`
                    });
                }
            }
    
            setDeleteModal(false);

            // Redirect to the home page after deleting the post
            // window.location.href = "/home";
        }

        // End

        const handleExternalLink = (url_link) => {
            console.log('About to Redirect..');
            
            // -- Analytics stuff -- 

            // Only track analytics if post is an active Ad
            if(ad.ads && ad.ads?.length > 0 && ad.ads[0].status === 'active' && post._id) {
                console.log('TRACKING POST ANALYTICS')
                safeTrackPostAnalytics('external_link_click', post._id);
            }

            // -- END: Analytics stuff -- 

            window.open(url_link, "_blank");
        }

        const handleProfileVisit = async () => {
            console.log('About to Visit Profile..');

            // -- Analytics stuff -- 

            // Only track analytics if post is an active Ad
            if(ad.ads && ad.ads?.length > 0 && ad.ads[0].status === 'active' && post._id) {
                console.log('TRACKING POST ANALYTICS')
                await safeTrackPostAnalytics('profile_visit', post._id);
            }

            // -- END: Analytics stuff -- 

            window.location.href = `/user/${post.user._id}`;
        }

        const handleGroupVisit = async () => {
            console.log("About to Visit Group page.."); 

            window.location.href = `/groups/${post.group?._id}?show=posts`;
        }

        // Message Logic

        const toggleMessageModal = () => {

            // Close other dropdowns
            setDropdown(false);
            setShareDropdown(false);

            // Get user by ID if the message modal is not currently open
            if(!messageModal) getUserById(post.user._id);
            
            setMessageModal(!messageModal);
        }
    
        const continueMessage = () => {
            if(auth.user) {

                // If the user is authenticated, create a new chat
                createNewChat();
            } else {

                // If the user is not authenticated, close the message modal and show the authentication modal
                setMessageModal(false);
                toggleAuthModal('message');
            }
        }

        const createNewChat = async () => {
            const chatsCollectionRef = collection(db, "chats");
    
            // Check if chat with 2 users already exists by chat ID
    
            console.log('CHECK USER CHAT HERE')

            try {
                // Query chats where the current user is the from_user and the modal user is the to_user
                const chatsQuery = query(chatsCollectionRef, where("from_user._id", "==", auth.user._id), where("to_user._id", "==", auth.modalUser._id));

                // Query chats where the modal user is the from_user and the current user is the to_user
                const otherChatsQuery = query(chatsCollectionRef, where("to_user._id", "==", auth.user._id), where("from_user._id", "==", auth.modalUser._id));
        
                // Query chats where the current user is the from_user and the modal user is the to_user
                const chatsSnapshot = await getDocs(chatsQuery);

                // Map the document snapshots to an array of chat objects, including the document ID
                const chats = chatsSnapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));
        
                // Query chats where the modal user is the from_user and the current user is the to_user
                const otherChatsSnapshot = await getDocs(otherChatsQuery);

                // Map the document snapshots to an array of chat objects, including the document ID
                const otherChats = otherChatsSnapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

                let chatRoomId;
        
                // If array length > 0 then there is already existing chat & redirect instead
            
                if(chats.length > 0) {

                    // -- Share post with user ---

                    // Send a message with postID attached
                    console.log('Sharing post...')
                    await addMessage({ formData: { postId: post._id }, imgData: null, imgDimensions: null, chatId: chats[0]._id, userObj: auth.user, notify_toId: post.user._id, website });

                    // -- END: Share post with user ---
                } else if (otherChats.length > 0) {

                    // -- Share post with user ---

                    // Send a message with postID attached
                    console.log('Sharing post...')
                    await addMessage({ formData: { postId: post._id }, imgData: null, imgDimensions: null, chatId: otherChats[0]._id, userObj: auth.user, notify_toId: post.user._id, website });

                    // -- END: Share post with user ---
                } else {

                    // Create a new chat if no existing chat is found
                    chatRoomId = await createChat(auth.modalUser, auth.user, post._id);

                    // -- Share post with user ---

                    // Send a message with postID attached
                    console.log('Sharing post...')
                    await addMessage({ formData: { postId: post._id }, imgData: null, imgDimensions: null, chatId: chatRoomId, userObj: auth.user, notify_toId: post.user._id, website });

                    // -- END: Share post with user ---
                }

                // -- Analytics stuff --

                // Only track analytics if post is an active Ad
                if(ad.ads && ad.ads?.length > 0 && ad.ads[0].status === 'active' && post._id) {
                    console.log('TRACKING POST ANALYTICS')
                    safeTrackPostAnalytics('direct_message', post._id);
                }

                // -- END: Analytics stuff --


                // -- Redirect to chat page --

                if(chats.length > 0) {
                    window.location.href = `/messages/${chats[0]._id}`;
                } else if (otherChats.length > 0) {
                    window.location.href = `/messages/${otherChats[0]._id}`;
                } else {
                    // Redirect to the chat page with the newly created chat room ID
                    if(chatRoomId) {
                        window.location.href = `/messages/${chatRoomId}`;
                    } else {
                        // Fallback: If something goes wrong go to messages page
                        window.location.href = `/messages`;
                    }
                }

                // -- END: Redirect to chat page --
        
                setMessageModal(!messageModal);
                
                console.log('SHOULD BE DONE CREATING');
                
            } catch (error) {
                console.log('Failed to create new chat');
                // console.log(error);
                setAlert('Unable to start conversation', 'danger');
            }
        }

        // End

        // -- Text Truncation Functions ---
    
        // Helper function
        const getPlainText = (html) => {
            const div = document.createElement('div');
            div.innerHTML = html;
            return div.textContent || div.innerText || '';
        };

        // -- END: Text Truncation Functions ---

        const capitalizeFirstLetter =(string) => {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }

        const detect_Links_phoneNumbers_Addresses =(string) => {
            // Regex to match URLs
            const urlRegex = /(?<![@\w])(?:https?:\/\/|www\.)?(?:[a-z0-9-]+\.)+[a-z]{2,}(?:\/[^\s<]*)?(?![\w@])/gi;

            // Regex for phone numbers (basic US-style, adjust if needed)
            // Matches formats like: 123-456-7890, (123) 456-7890, 1234567890, +1 123 456 7890
            const phoneRegex = /(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?){1,2}\d{4}/g;

            // Regex for addresses (US-style)
            // Matches things like: 123 Main St | 456 Elm Street, Springfield | 789 Broadway Ave, Apt 5, New York
            // TODO: Use a location keyword list to improve detection (i.e. city names, states, countries)
            const addressRegex = /\d{1,5}\s[\w\s]{1,30}\s(?:Street|St|Avenue|Ave|Boulevard|Blvd|Road|Rd|Lane|Ln|Drive|Dr|Court|Ct|Way|Wy|Plaza|Circle|Ct|Terrace|Ter|Trail|Trl)\b(?:,\s?[\w\s]+)*/gi;

            // 1st wrap URLs with <a> tags
            let temp_result = string.replace(urlRegex, (url) => {

                // If the URL already starts with http:// or https://, leave it
                // Otherwise, prepend http://
                // (purpose: makes sure the link redirects properly)
                const safe_url = /^(https?:\/\/)/i.test(url) ? url : `http://${url}`;

                return `<a href="${safe_url}" class='hoverable_link' target="_blank" rel="noopener noreferrer">${url}</a>`;
            });

            // 2nd replace phone numbers
            temp_result = temp_result.replace(phoneRegex, (phone) => {
                // Remove spaces/dashes for href
                const tel = phone.replace(/[-.\s()]/g, "");
                return `<a href="sms:${tel}" class='hoverable_link'>${phone}</a>`;
            });

            // 3rd replace addresses with Google Maps links
            temp_result = temp_result.replace(addressRegex, (address) => {
                const href = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
                return `<a href="${href}" class='hoverable_link' target="_blank" rel="noopener noreferrer">${address}</a>`;
            });

            return temp_result;
        }
    
        // Check if the authenticated user exists and the checkLike flag is false
        if(auth.user && !checkLike) {

            // Filter the likes array of the post to check if the authenticated user has liked the post
            if(post.likes.filter(like => like.user._id.toString() === auth.user._id).length > 0){

                // If the authenticated user has liked the post, set the liked state to true
                setLiked(true);
            }
            
            // Set the checkLike flag to true to indicate that the check has been performed
            setCheckLike(true);
        }  

        // Converts the DraftJS text to HTML and sets the converted text
        useEffect(() => {
            if (post && !gotText) {
                let unRawState;
                let unRawDescription;

                if(post.text) {
                    try {
                        // Convert stringified DraftJS JSON to a raw JS object
                        const rawBlocksData = JSON.parse(post.text);

                        // Extract just the array of text blocks
                        if (rawBlocksData && Array.isArray(rawBlocksData.blocks)) {
                            unRawState = EditorState.createWithContent(
                                convertFromRaw(rawBlocksData)
                            );

                            unRawDescription = draftToHtml(convertToRaw(unRawState.getCurrentContent()));
                        } else {
                            unRawDescription = post.text;
                        }

                        // -- Detect URLs & Phone #'s in text ---

                        unRawDescription = detect_Links_phoneNumbers_Addresses(unRawDescription);
                        
                        // -- END: Detect URLs & Phone #'s in text ---

                        // -- Text Truncation Functions ---

                        // Check if truncation is needed
                        const plainText = getPlainText(unRawDescription);
                        const shouldTruncate_temp = plainText.length > CHARACTER_LIMIT;
                        const truncated_text = plainText.substring(0, CHARACTER_LIMIT) + '...';
                        setShouldTruncate(shouldTruncate_temp);

                        // -- END: Text Truncation Functions ---

                        setRawTextState(unRawDescription);

                        setTextState(detect_Links_phoneNumbers_Addresses(truncated_text));
                    } catch (error) {
                        const text_final = detect_Links_phoneNumbers_Addresses(post.text);
                        
                        setRawTextState(text_final);
                        setTextState(text_final);
                    }
                }
                
                // Marks that the text conversion has been performed
                setGotText(true);
            }
        }, [post, gotText]);

        const myRef = useRef(null)

        // run this function from an event handler or an effect to execute scroll 
        const executeScroll = () => {
            myRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        let parentPostList;

        // Check if posts are null or not yet fetched
        if(post !== null && gotParentPosts) {
            if(parentPosts.length > 0) {

                // Iterate through the parentPosts array and render each post component
                parentPostList = parentPosts.map(parentPost => {
                    return (
                        <Post key={parentPost._id} postDoc={parentPost} executeScroll={executeScroll} />
                    )
                })
            }
        }

        // --- ImageKit (img optimization service) ---

        let optimized_post_avatar_path = null;

        if(showGroupName) {
            if(post.group?.avatar) {
                optimized_post_avatar_path = post.group.avatar.replace("https://firebasestorage.googleapis.com","https://ik.imagekit.io/pba3w2st28/");
            }
        } else {
            if(post.user.img) {
                optimized_post_avatar_path = post.user.img.replace("https://firebasestorage.googleapis.com","https://ik.imagekit.io/pba3w2st28/");
            }
        }

        return (
            <Fragment>
                {/* Display parent posts */}
                {parentPostList && parentPostList}

                <div className="postPage">

                    {/* Solution to fix the scrollIntoView going too far problem - see the 'myRef' */}
                    {parentPostList && (
                        <div ref={myRef} style={{height:'70px', width:'100px', marginTop:'-70px'}}></div>
                    )}

                    {/* More Button - trigger dropdown */}
                    <div onClick={() => setDropdown(!dropdown)} className={`post__moreBtn ${parentPostList ? 'has_parent_post' : ''}`}>
                        <MoreHorizIcon />
                    </div>

                    {(ad.ads.length > 0 && ad.ads[0].status === 'active') && (
                        <span className='post__adLabel icon_16'>
                            Boosted
                            <span style={{width: '3px'}}></span>
                            <TrendingUpIcon />
                        </span>
                    )}

                    {(ad.ads.length > 0 && ad.ads[0].status === 'paused' && auth.user && post?.user._id === auth.user._id) && (
                        <span className='post__adLabel icon_16'>
                            Ad Paused
                            <span style={{width: '3px'}}></span>
                            <PauseIcon />
                        </span>
                    )}

                    {/* More btn Dropdown Menu */}
                    <div className={dropdown ? "edit-dropdown active" : "edit-dropdown"} style={{height: menuHeight}}>
                        <div className="menu">

                            {/* Copy Link Menu Item */}
                            <CopyToClipboard 
                                text={`${website ? website.url : process.env.REACT_APP_DOMAIN}/post/${post._id}?redirect=true`}
                                onCopy={toggleCopiedModal}
                            >
                                <div className="menu-item">
                                    {!copied ? (
                                        <Fragment>
                                            <LinkIcon />
                                            Copy link
                                        </Fragment>
                                    ) : (
                                        <Fragment>
                                            <CheckIcon />
                                            Copied!
                                        </Fragment>
                                    )}
                                </div>
                            </CopyToClipboard>

                            {auth.user && post.user._id !== auth.user._id && (
                                <div onClick={toggleMessageModal} className="menu-item">
                                    <MailIcon />
                                    Send Message
                                </div>
                            )}

                            {/* Delete Menu Item (shown only for authenticated user who created the post) */}
                            {auth.user && post.user._id === auth.user._id ? (
                                <Fragment>
                                    <div onClick={() => window.location.href = `/post/${post._id}/boost`} className="menu-item">
                                        <TrendingUpIcon />
                                        Boost Post
                                    </div>
                                    <div onClick={toggleDeleteModal} className="menu-item danger">
                                        <DeleteIcon />
                                        Delete
                                    </div>
                                </Fragment>
                            ) : null}
                        </div>
                    </div>

                    {/* Hidden Overlay for more btn dropdown */}
                    <div
                        className={`hidden-overlay ${dropdown ? "show" : ""}`}
                        onClick={() => setDropdown(!dropdown)}
                    />

                    {/* Detail Post Header - top */}
                    <div className="postPage__header">

                        {/* Display the user avatar - links to profile page */}
                        <div onClick={showGroupName ? handleGroupVisit : handleProfileVisit} className="postPage__avatar">

                            {optimized_post_avatar_path ? (
                                <Avatar src={optimized_post_avatar_path && optimized_post_avatar_path} />
                            ) : (
                                <DefaultAvatar name={showGroupName ? `${post.group.name}` : `${post.user.first_name} ${post.user.last_name}`} />
                            )}
                        </div>
                        <div className="postPage__headerText">
                            {/* Display name */}
                            <div style={{display: 'flex'}}>
                                <h3>
                                    {/* Show group name OR user name */}
                                    {showGroupName ? (
                                        <span onClick={handleGroupVisit} className='hover_underline'>
                                            <span>{post.group.name}</span>
                                        </span>
                                    ) : (
                                        <span onClick={handleProfileVisit} className='hover_underline'>
                                            <span>{post.username && post.username + ' '} </span>

                                            {/* Display the verified badge if the user is verified */}
                                            <span className="postPage__headerSpecial">
                                                <Verification_Badge user={post.user} />
                                            </span>
                                        </span>
                                    )}
                                </h3>
                                {/* Post author */}
                                {showGroupName && (
                                    <Fragment>
                                        <h3 style={{margin: '0 3px'}}>&middot;</h3>
                                        <p>
                                            <span onClick={handleProfileVisit} className='hover_underline'>
                                                <span>{post.username && post.username + ' '}</span>
                                            </span>
                                            <span className="postPage__headerSpecial">
                                                <Verification_Badge user={post.user} />
                                            </span>
                                        </p>
                                    </Fragment>
                                )}
                            </div>
                            {(replyToPost && replyToPost.user?.username)&& (
                                <div className='replying_to_title'>
                                    Replying to {' '}
        
                                    <a href={`/user/${replyToPost.user._id}`}>
                                        {replyToPost.user.first_name} {replyToPost.user.last_name && ' ' + replyToPost.user.last_name}
                                    </a>
                                </div>
                            )}
                            <p>{formatDistanceToNow(post.date)} ago</p>

                            <div style={{display: 'flex', alignItems: 'center'}}>
                                {(post.price) && (
                                    <Tag text={post.price} classes={"margin_top margin_right"} price_tag />
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Detail Post Body - bottom */}
                    <div className="postPage__body">

                        {/* Render the post text content */}
                        {textState !== null && (
                            <div className={`postPage__headerDescription ${hasImg ? 'withImgs' : ''} ${shouldTruncate ? 'shouldTruncate' : ''} `}>
                                {/* <p>{post.text ? post.text : null}</p> */}

                                {/* Render the converted HTML text description */}
                                {!isExpanded && shouldTruncate 
                                    ? <div className='break_long_words' dangerouslySetInnerHTML={{__html: textState}} /> 
                                    : <div className='break_long_words' dangerouslySetInnerHTML={{__html: rawTextState}} />}

                                {shouldTruncate && (
                                    <span 
                                        className='post_see_more_btn'
                                        onClick={() => setIsExpanded(!isExpanded)}
                                    >
                                        {isExpanded ? 'See less' : 'See more'}
                                    </span>
                                )}
                            </div>
                        )}
                        
                        {/* <div className="postPage__img">
                            {post.img && <img src={post.img} alt="" />}
                        </div> */}

                        {/* Display the post images if available */}
                        <ImageBlock 
                            detailPost={post} 
                            setHasImg={setHasImg} 
                            setCheckHasImg={setCheckHasImg} 
                            checkHasImg={checkHasImg} 
                            setImgHeight={setImgHeight}
                        />

                        {hasImg && (
                            // Spacing Element
                            <div style={{height: `${imgHeight+20}px`}} />
                        )}
                        {/* Display the post timestamp */}
                        <div className="postPage__timeStamp">
                            <p>{format(post.date, "h:mm a")}</p>
                            <p>{format(post.date, "MMM do")}</p>
                        </div>
                        
                        {/* Render the "Send Message" button based on user authentication */}
                        {auth.user && post.user._id !== auth.user._id && post ? (
                            <Fragment>
                                {(!ad.loading && ad.ads.length > 0 && ad.ads[0].status === 'active' && ad.ads[0].cta.type === "website") ? (
                                    <Button onClick={() => handleExternalLink(ad.ads[0].cta.url)} variant="outlined" className="sidebar__tweet black" style={{zIndex: 10, position: 'relative'}} fullWidth>
                                        {ad.ads[0].cta.label}
                                        {ad.ads[0].cta.label.toLowerCase() === 'shop now' && (
                                            <Fragment>
                                                <span style={{width: '5px'}}></span>
                                                <LocalMallOutlinedIcon />
                                            </Fragment>
                                        )}
                                        {ad.ads[0].cta.label.toLowerCase() === 'visit website' && (
                                            <Fragment>
                                                <span style={{width: '5px'}}></span>
                                                <LinkOutlinedIcon />
                                            </Fragment>
                                        )}
                                    </Button>
                                ) : (
                                    <Button onClick={toggleMessageModal} variant="outlined" className="sidebar__tweet icon_18" fullWidth>
                                        Send Message
                                        <span style={{width: '5px'}}></span>
                                        <MailIcon />
                                    </Button>
                                )}
                            </Fragment>
                        ) : null} 
                        
                        {!auth.user ? (
                            <Button onClick={toggleMessageModal} variant="outlined" className="sidebar__tweet icon_18" fullWidth>
                                Send Message
                                <span style={{width: '5px'}}></span>
                                <MailIcon />
                            </Button>
                        ) : null} 

                        {post && auth.user && post.user._id === auth.user._id && !ad.loading ? (
                            <Fragment>
                                {ad.ads.length > 0 ? (
                                    <Fragment>
                                        {(ad.ads[0].status === 'stopped' || ad.ads[0].status === 'completed') ? (
                                            <Button onClick={() => window.location.href = `/post/${post._id}/boost`} variant="outlined" className="sidebar__tweet green" fullWidth>
                                                Boost Again
                                                <span style={{width: '5px'}}></span>
                                                <TrendingUpIcon />
                                            </Button>
                                        ) : (
                                            <Button onClick={() => window.location.href = `/ads/${ad.ads[0]._id}`} variant="outlined" className="sidebar__tweet ghost" fullWidth>View Analytics</Button>
                                        )}
                                    </Fragment>
                                ) : (
                                    <Button onClick={() => window.location.href = `/post/${post._id}/boost`} variant="outlined" className="sidebar__tweet green" fullWidth>Boost for $5</Button>
                                )}
                            </Fragment>
                        ) : null} 

                        {/* Render the post statistics */}
                        {/* {(commentList?.length > 0 || post.likes.length > 0) && (
                            <div className="postPage__stats">

                                {commentList.length > 0 && (
                                    <div className="postPage__stat">

                                       
                                        <span>{commentList.length}</span>
                                        &nbsp;
                                        <span style={{color: 'rgb(83, 100, 113)'}}>Comments</span>

                                    </div>
                                )}

                             
                                {post.likes.length > 0 && (
                                    <div className="postPage__stat">

                                    
                                        <a href={`/post/${post._id}/likes`}>
                                            <span>{post.likes.length}</span>
                                            &nbsp;
                                            <span style={{color: 'rgb(83, 100, 113)'}}>Likes</span>
                                        </a>
                                    </div>
                                )}
                            </div>
                        )} */}

                        <div className="postPage__actions">
                            <div>

                                {/* Comment button */}
                                <button 
                                    onClick={() => {
                                        if(auth.user) {
                                            if(isTablet) {
                                                redirectComment()
                                            } else {
                                                toggleCommentModal()
                                            }
                                        } else {
                                            getUserById(post.user._id);
                                            toggleAuthModal('comment');
                                        }
                                    }}                   
                                    className="secondaryBtn post"
                                >
                                    <div>
                                        {/* Btn Icon */}
                                        <ChatBubbleOutlineIcon fontSize="small" />
                                        {/* Btn Text */}
                                        <span>Comment</span>
                                    </div>
                                </button>
                            </div>
                            <div className={liked ? "active" : "" } onClick={() => handleLike(post._id)}>

                                {/* Like button */}
                                <button className={liked ? "secondaryBtn post active" : "secondaryBtn post like" }>
                                    <div>

                                        {/* Render the like icon based on whether the post is liked */}
                                        {liked ? <FavoriteIcon fontSize="small" /> : <FavoriteBorderIcon fontSize="small" />}

                                        {/* Btn Text w/ like qty */}
                                        <span>{liked ? 'Saved!' : 'Save'} {post.likes.length > 0 && (
                                            <span style={liked ? {display:'none'}: {fontSize:'11px'}}>({post.likes.length})</span>
                                        )}</span>
                                    </div>
                                </button>
                            </div>
                        
                            
                            <div style={{position: 'relative'}}>

                                {/* Share button */}
                                <button onClick={() => setShareDropdown(!shareDropdown)} className="secondaryBtn post share">
                                    <div>
                                        {/* Btn Icon */}
                                        <ShareIcon fontSize="small" />
                                        {/* Btn Text */}
                                        <span>Share</span>
                                    </div>
                                </button>

                                {/* Share btn Dropdown menu */}
                                <div className={shareDropdown ? "edit-dropdown active" : "edit-dropdown"} style={{height: menuHeight}}>
                                    <div className="menu">

                                        {/* Copy post link to clipboard */}
                                        <CopyToClipboard 
                                            text={`${website ? website.url : process.env.REACT_APP_DOMAIN}/post/${post._id}?redirect=true`}
                                            onCopy={toggleCopiedModal}
                                        >
                                            <div className="menu-item">
                                                {!copied ? (
                                                    <Fragment>
                                                        <LinkIcon />
                                                        Copy link
                                                    </Fragment>
                                                ) : (
                                                    <Fragment>
                                                        <CheckIcon />
                                                        Copied!
                                                    </Fragment>
                                                )}
                                            </div>
                                        </CopyToClipboard>
                                    </div>
                                </div>

                                {/* Hidden Overlay for share btn dropdown */}
                                <div
                                    className={`hidden-overlay ${shareDropdown ? "show" : ""}`}
                                    onClick={() => setShareDropdown(!shareDropdown)}
                                />
                            </div>
                        </div>

                    </div>
                </div>

                {/* Delete Post Modal */}
                <ModalContainer show={deleteModal} onClose={toggleDeleteModal}>
                    <Modal>

                        {/* Modal Title */}
                        <div>
                            <h2>Delete Post?</h2>
                        </div>

                        {/* Modal Description */}
                        <p>This can’t be undone and it will be removed from your profile, the main feed, and from any search results.</p>

                        {/* Modal Actions */}
                        <Button 
                            onClick={handleDelete}
                            variant="outlined" 
                            className="sidebar__tweet danger"
                            fullWidth
                        >
                            Delete
                        </Button>
                        <Button 
                            onClick={toggleDeleteModal}
                            variant="outlined" 
                            className="sidebar__tweet ghost"
                            fullWidth
                        >
                            Cancel
                        </Button>
                    </Modal>
                </ModalContainer>

                {/* Create Message confirmation Modal */}  
                <ModalContainer show={messageModal} onClose={toggleMessageModal}>
                    <Modal>

                        {/* Modal Title */}
                        <div>
                            <h2>Start Conversation?</h2>
                        </div>

                        {/* Modal Description */}
                        <p>Start a private conversation with <b style={{color: '#333'}}>{post.username ? post.username : 'this person'}</b></p>
                        
                        {/* Modal Actions */}
                        <Button 
                            onClick={continueMessage}
                            variant="outlined" 
                            className="sidebar__tweet black"
                            fullWidth
                        >
                            Start Conversation
                        </Button>
                        <Button 
                            onClick={toggleMessageModal}
                            variant="outlined" 
                            className="sidebar__tweet ghost blackText"
                            fullWidth
                        >
                            Cancel
                        </Button>
                    </Modal>
                </ModalContainer>

                {/* Copied Link Modal */}
                <ModalContainer show={copiedModal} onClose={toggleCopiedModal} white>
                    <Modal border>

                        {/* Modal Title */}
                        <div>
                            <h2>Link Copied!</h2>
                        </div>

                        {/* Modal Description */}
                        <p>You can share this link with anyone.</p>
                        
                        {/* Modal Actions */}
                        <Button 
                            onClick={toggleCopiedModal}
                            variant="outlined" 
                            className="sidebar__tweet ghost"
                            fullWidth
                        >
                            Close
                        </Button>
                    </Modal>
                </ModalContainer>
            </Fragment>
        )
}

Detail.propTypes = {
    setAlert: PropTypes.func.isRequired, // Function prop to set an alert
    addLike: PropTypes.func.isRequired, // Function prop to add a like to a post
    deletePost: PropTypes.func.isRequired, // Function prop to delete a post
    getUserById: PropTypes.func.isRequired, // Function prop to retrieve user data by ID
    createChat: PropTypes.func.isRequired, // Function prop to create a chat conversation
    addMessage: PropTypes.func.isRequired,
    toggleAuthModal: PropTypes.func.isRequired, // Function prop to toggle the authentication modal
    auth: PropTypes.object.isRequired, // Object prop representing the authentication data for the user
    ad: PropTypes.object.isRequired,
    nav: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
    
    // Mapping the auth state from the Redux store to the 'auth' prop
    auth: state.auth,
    ad: state.ad,
    nav: state.nav
});

export default connect(mapStateToProps, { 

    // Connecting actions from redux to the component
    setAlert, 
    addLike, 
    deletePost, 
    getUserById, 
    createChat, 
    addMessage,
    toggleAuthModal 
})(Detail);
